import React from 'react'
import { useTheme } from '@mui/material/styles'
import { Avatar, Badge, Box, ButtonBase } from '@mui/material'
import { IconMessage } from '@tabler/icons'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

const ChatSection = () => {
  const theme = useTheme()
  const navigate = useNavigate()
  const { header_info } = useSelector((state) => state.summaryHeader)

  const handleToggle = () => {
    navigate('/chat')
  }
  return (
    <>
      <Box
        sx={{
          ml: 2,
          mr: 1,
          [theme.breakpoints.down('md')]: {
            mr: 2,
          },
        }}
      >
        <Badge badgeContent={header_info.chat_unread ?? 0} max={99} color="error">
          <ButtonBase sx={{ borderRadius: '12px' }}>
            <Avatar
              variant="rounded"
              sx={{
                ...theme.typography.commonAvatar,
                ...theme.typography.mediumAvatar,
                transition: 'all .2s ease-in-out',
                background: 'transparent',
                color: theme.palette.grey[700],
                '&[aria-controls="menu-list-grow"],&:hover': {
                  background: 'transparent',
                  color: theme.palette.primary.main,
                },
              }}
              onClick={handleToggle}
              color="inherit"
            >
              <IconMessage stroke={1.5} size="3rem" />
            </Avatar>
          </ButtonBase>
        </Badge>
      </Box>
    </>
  )
}

export default ChatSection
